import { render } from "./header.vue?vue&type=template&id=5974132e&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=5974132e&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=5974132e&lang=scss"

import exportComponent from "D:\\Project\\DeepLink\\DeepLinkWebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5974132e"]])

export default __exports__